export const COMMON_VIDEO_EXTENSIONS = ['mp4', 'avi', 'mov', 'm4v', 'wmv', 'mkv', 'webm'];

export const STUDIO_VIDEO_EXTENSIONS = ['mp4', 'webm', 'm3u8', 'mov']

export const UPLOADS_VIDEO_EXTENSIONS = [...COMMON_VIDEO_EXTENSIONS, 'm2ts', 'ts'];
